// extracted by mini-css-extract-plugin
export default {"overlay":"Spinner_overlay__TbFvc","fadeIn":"Spinner_fadeIn__mX4u-","spinning":"Spinner_spinning__Q1MzW","spinner":"Spinner_spinner__Qz7DP"};